<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :back_href="'/building-personel'"
    />    
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'CostCenterPersonelDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `personels/${this.$route.params.id}`,
            lite_rest_api:      `personels`,
            rest_api_note:      `personel_notes`,
            form_format:        FormResources.form_format,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {},
        }
    },

    methods:{

        fill_data(data) {
            this.single_object  = data.personel;
           this.array_options = {
                cost_center_id: data.cost_centers,
                cost_center_department_id: []
            }
            this.title_page     = this.single_object.name;
            this.breadcrumb[1].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.name,
                href:   '#',
                arrow:  " ",
            });
        },

    },

    async mounted(){
        
         if(this.hasPermissions(['Building-Personel Read-Write', 'Building-Personel Read-Only']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },

    watch: {

        async "single_object.cost_center_id"(val) {
            if (val) {
                let http_request = {
                    request_id: val,
                    department_request: true,
                };
                const response = await this.get(`${this.lite_rest_api}/${JSON.stringify(http_request)}`);
                if(response.status) {
                    if (response.data.departments.length) {
                        this.array_options.cost_center_department_id = response.data.departments;

                        let states_object = this.array_options.cost_center_department_id.find((key)=>{
                            return key.id === this.single_object.cost_center_department_id 
                        })

                        states_object === undefined ? 
                            this.single_object.cost_center_department_id = this.array_options.cost_center_department_id[0].id :
                            this.single_object.cost_center_department_id = states_object.id;
                        
                    } else {
                        this.array_options.cost_center_department_id = [];
                        this.single_object.cost_center_department_id = "";
                    }

                } else {
                    this.error_handling(response)
                }

            }
        },
    }
}
</script>